module.exports = __webpack_public_path__ + "static/media/add-logo.00636df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/add-logo.png
// module id = 694
// module chunks = 0